package com.zaurh.mapquizwebsite.presentation.screen.main.components

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.AlertDialog
import androidx.compose.material3.Button
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.material3.TextField
import androidx.compose.material3.TextFieldDefaults
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.ui.Modifier
import androidx.compose.ui.focus.FocusRequester
import androidx.compose.ui.focus.focusRequester
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.input.pointer.PointerIcon
import androidx.compose.ui.input.pointer.pointerHoverIcon
import androidx.compose.ui.platform.LocalFocusManager
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.unit.dp
import com.zaurh.mapquizwebsite.utils.getOutfitFont
import mapquizwebsite.shared.generated.resources.Res
import mapquizwebsite.shared.generated.resources.mapquiz_logo
import org.jetbrains.compose.resources.painterResource

@Composable
fun SignInAlert(
    isVisible: Boolean,
    value: String,
    onDismiss: () -> Unit,
    onValueChange: (String) -> Unit,
    onSignInClicked: () -> Unit
){
    val focusManager = LocalFocusManager.current
    val focusRequester: FocusRequester = FocusRequester()

    LaunchedEffect(isVisible){
        if (isVisible){
            focusRequester.requestFocus()
        }
    }

    if (isVisible){
        AlertDialog(
            containerColor = MaterialTheme.colorScheme.surface,
            onDismissRequest = {
                onDismiss()
            },
            icon = {
                Image(
                    painter = painterResource(Res.drawable.mapquiz_logo),
                    contentDescription = null,
                    modifier = Modifier.size(128.dp)
                )
            },
            title = {
                Text(text = "Welcome to MapQuiz", fontFamily = getOutfitFont())
            },
            text = {
                TextField(
                    value = value,
                    onValueChange = onValueChange,
                    placeholder = {
                        Text(text = "Enter your username", fontFamily = getOutfitFont())
                    },
                    colors = TextFieldDefaults.colors(
                        focusedContainerColor = MaterialTheme.colorScheme.background,
                        unfocusedContainerColor = MaterialTheme.colorScheme.background,
                        focusedIndicatorColor = Color.Transparent,
                        unfocusedIndicatorColor = Color.Transparent,
                        cursorColor = MaterialTheme.colorScheme.primary
                    ),
                    maxLines = 1,
                    shape = RoundedCornerShape(10.dp),
                    modifier = Modifier.focusRequester(focusRequester),
                    textStyle = TextStyle.Default.copy(
                        fontFamily = getOutfitFont()
                    )
                )
            },
            confirmButton = {
                Button(
                    onClick = {
                        onSignInClicked()
                    },
                    modifier = Modifier.pointerHoverIcon(
                    if (value.isNotBlank()) PointerIcon.Hand else PointerIcon.Default
                ), enabled = value.isNotBlank()){
                    Text(text = "Sign in", fontFamily = getOutfitFont())
                }
            }
        )
    }
}